import { render, staticRenderFns } from "./import-result.vue?vue&type=template&id=6212a4b0&scoped=true&"
import script from "./import-result.vue?vue&type=script&lang=js&"
export * from "./import-result.vue?vue&type=script&lang=js&"
import style0 from "./import-result.vue?vue&type=style&index=0&id=6212a4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212a4b0",
  null
  
)

export default component.exports